module.exports = __webpack_public_path__ + "img/donante-manos-entrelazadas.4783ce5d.png";